import React, { type JSX } from "react";
import { formatAdminDate } from "../formatting/format-admin-date";

type AdminLiveRangeBannerProps = {
  explicitUpperBound: string;
  locale: "ko" | "en";
  onResetToLive: () => void;
};

export function AdminLiveRangeBanner(props: AdminLiveRangeBannerProps): JSX.Element {
  const copy =
    props.locale === "ko"
      ? {
          title: "고정된 종료 시각 때문에 실시간 갱신이 멈춰 있습니다",
          bodyPrefix: "현재 URL에 고정된 조회 종료 시각이 포함되어 있어",
          bodyMiddle: "이후 데이터는 내림차순 정렬을 해도 나타나지 않습니다.",
          bodySuffix: "`실시간 범위로 복귀`를 누르면 from/to/cursor를 지우고 다른 필터는 유지한 채 최신 범위로 다시 조회합니다.",
          button: "실시간 범위로 복귀",
        }
      : {
          title: "Live refresh is paused because the query end time is fixed",
          bodyPrefix: "The current URL contains a fixed query upper bound, so rows after",
          bodyMiddle: "will not appear even if you sort descending.",
          bodySuffix: "Use `Return to live range` to clear from/to/cursor while keeping the other filters.",
          button: "Return to live range",
        };

  return (
    <section
      style={{
        padding: "16px 18px",
        borderRadius: "20px",
        border: "1px solid rgba(249, 115, 22, 0.28)",
        background: "rgba(255, 247, 237, 0.92)",
        display: "grid",
        gap: "12px",
      }}
    >
      <div style={{ display: "grid", gap: "6px" }}>
        <p style={{ margin: 0, color: "#9a3412", fontWeight: 700 }}>{copy.title}</p>
        <p style={{ margin: 0, color: "#7c2d12", lineHeight: 1.6 }}>
          {copy.bodyPrefix} {formatAdminDate(props.explicitUpperBound)} {copy.bodyMiddle} {copy.bodySuffix}
        </p>
      </div>
      <div>
        <button
          onClick={props.onResetToLive}
          style={{
            minHeight: "40px",
            padding: "0 16px",
            borderRadius: "999px",
            border: "1px solid rgba(249, 115, 22, 0.35)",
            background: "#fff7ed",
            color: "#9a3412",
            fontWeight: 700,
            cursor: "pointer",
          }}
          type="button"
        >
          {copy.button}
        </button>
      </div>
    </section>
  );
}
